import { Icon } from "@/components/Primitives"
import { useConfig } from "@/hooks/useConfig"
import { MissionResource } from "@/types/quests"
import { Download } from "lucide-react"
import { Text } from "@/components/Primitives/Text"

export function MissionResourceContainer({
  resources,
}: {
  resources: MissionResource[]
}) {
  const { t } = useConfig()

  return resources.length > 0 ? (
    <div className="border-t border-gray-200 pt-4">
      <div className="bg-neutral-100 border border-gray-200 rounded-xl p-4">
        <div className="flex items-center mb-3 gap-2 font-semibold text-xl">
          {t("config_mission_resource_title")}
        </div>
        <div className="space-y-3">
          {resources.map((resource: MissionResource, idx: number) => (
            <div
              key={idx}
              className="flex items-center bg-neutral-100 rounded-lg border p-3 gap-3 border-neutral-200 "
            >
              <div className="flex-shrink-0">
                <img
                  src="/images/resource.png"
                  alt=""
                  className="inline-block align-middle"
                  width={40}
                  height={40}
                />
              </div>
              <div className="flex-1 min-w-0">
                <Text variant="paragraph">{resource.name}</Text>
              </div>
              <a
                href={resource.url}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-3 p-3 rounded-lg bg-neutral-200 hover:bg-neutral-400 transition-colors"
                title="Download resource"
              >
                <Icon icon={Download} className="w-4 h-4 text-black" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null
}
